<template>
    <transition
        :css="false"
        @enter="intro"
        @leave="outro"
    >
        <div class="IntroLogo">
            <svg
                class="IntroLogo-stage"
                :viewBox="stageViewBox"
                :style="stageStyle"
            >
                <path ref="number" class="IntroLogo-number" :d="data.number"></path>
                <path
                    ref="chars"
                    class="IntroLogo-char"
                    v-for="(char, i) in data.chars"
                    :key="i"
                    :d="char"
                ></path>
            </svg>
        </div>
    </transition>
</template>

<script>
    import {random} from '../../foo/utils/MathUtils.js'

    export default {
        name: 'IntroLogo',
        props: {
            introDelay: {
                type: Number,
                default: 0,
            },
            charMinDuration: {
                type: Number,
                default: 1,
            },
            charMaxDuration: {
                type: Number,
                default: 2,
            },
            outroDelay: {
                type: Number,
                default: 0,
            },
            outroDuration: {
                type: Number,
                default: 0.75,
            },
        },
        methods: {
            async intro($el, done) {
                const {$refs} = this
                // Reset container opacity
                TweenLite.set($el, {alpha: 1})
                // Single char tween
                const tweens = $refs.chars.map(char => this.getCharTween(char))
                // Add background number anim to tweens
                tweens.push(this.getNumberTween())
                // Wait until all tweens finish to call done
                await Promise.all(tweens)
                done()
            },
            outro($el, done) {
                const {outroDelay, outroDuration} = this
                TweenLite.to($el, outroDuration, {
                    alpha: 0,
                    ease: Cubic.easeOut,
                    delay: outroDelay,
                    onComplete: done,
                })
            },
            getNumberTween() {
                return new Promise((resolve, reject) => {
                    const {$refs, introDelay, charMaxDuration} = this
                    TweenLite.fromTo($refs.number, charMaxDuration, {alpha: 0}, {
                        alpha: 1,
                        delay: introDelay,
                        onComplete: resolve,
                    })
                })
            },
            getCharTween(char) {
                return new Promise(resolve => {
                    const {charMinDuration, charMaxDuration, introDelay} = this
                    let duration = random(charMinDuration, charMaxDuration)
                    let delay = introDelay + charMaxDuration - duration
                    TweenLite.fromTo(char, duration, {alpha: 0}, {
                        alpha: 1,
                        delay,
                        onComplete: resolve,
                    })
                })
            },
        },
        computed: {
            data() {
                const {$store} = this
                return $store.getters.data.intro.logo
            },
            stageStyle() {
                const {data} = this
                return {
                    'width': `${data.width}px`,
                    'height': `${data.height}px`,
                }
            },
            stageViewBox() {
                const {data} = this
                return `0 0 ${data.width} ${data.height}`
            },
        },
    }
</script>

<style src="styles/components/IntroLogo.styl" lang="stylus"></style>



// WEBPACK FOOTER //
// src/app/components/IntroLogo.vue